import { Box } from '@mui/material';
import React from 'react';
import { ToggleOff } from '@mui/icons-material';
import { VegaAccordian } from '../../../../../../components/common';
import { toLowerCase } from '../../../../../../constants/commonFunction';
// import FeesWaiverTable from './FeesWaiverTable';
import { BORDER_GRAY } from '../../../../../../constants/style';
import { ITransactionRulesProps } from '../TransactionLimit';
import VelocityTransactionLimitTable from './VelocityTransactionLimitTable';

export interface IProps {
  rule: ITransactionRulesProps | null;
  headerPrefix?: string;
  code: string;
  onActivationClick: (code: string) => void;
  // isDisabled?: boolean;
  handleChange: (code: string, key: string, value: any) => void;
}

const TransactionLimitCard = ({
  rule,
  code,
  onActivationClick,
  handleChange,
}: IProps) => {
  return (
    <Box sx={{ my: 2 }}>
      <VegaAccordian
        expandIcon={
          <ToggleOff fontSize="large" color={!!rule ? 'success' : 'disabled'} />
        }
        expanded={!!rule}
        onChange={() => onActivationClick(code)}
        header={toLowerCase(code)}
        noPad
        content={
          rule && (
            <>
              <VelocityTransactionLimitTable
                rule={rule}
                code={code}
                handleChange={(key, value) => handleChange(code, key, value)}
              />
            </>
          )
        }
      />
    </Box>
  );
};

export default TransactionLimitCard;
